import React, { useState } from "react";
import "./carousel-rates.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CardRates from "../../atoms/card-rates/card-rates";
import Button from "../../atoms/button/button";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
import GlobalContext from "../../../contexts/globalContext";
import { GatsbyImage } from "gatsby-plugin-image";
const CarouselRates = (props: ReferenciaContenido) => {
  const carouselData = props;
  const datasRates = props.referenciaPlantillaContenido;
  const [isMenuActive, setMenuActive] = useState(0);
  const [isMenuCurrActive, setMenuCurrActive] = useState(0);
  let scrollingDraw = 0.9;
  let scrollingDraw2 = 1;

  const setting = {
    dots: false,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4.4,
    slidesToScroll: 1.2,
    initialSlide: 0,
    beforeChange: (current, next) => {
      setMenuCurrActive(next);
    },
    afterChange: (current) => {
      setMenuActive(Math.round(current));
    },
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 560,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 440,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll:
            isMenuCurrActive <= 0 ? scrollingDraw : scrollingDraw2,
        },
      },
    ],
  };

  return (
    <GlobalContext.Consumer>
      {(data) => (
        <div className="m-carousel">
          <div className="m-carousel-rates">
            <h2>{carouselData.tituloGeneral}</h2>
            <div className="m-carousel-rates__transversal">
              <Slider {...setting}>
                {datasRates.map((val, key) => {
                  return (
                    <div className={`m-carousel-rates__mini `} key={key}>
                      {val.imagenPrincipal ? (
                        <CardRates
                          className={`${
                            isMenuActive === key ? "cardborder" : " cardnone"
                          } ${val.imagenPrincipal ? "changes_card" : ""} `}
                        >
                          <div className="m-carousel-rates__images">
                            <GatsbyImage
                              className="m-carousel-rates__images-img"
                              image={val.imagenPrincipal[0].gatsbyImageData}
                              alt={val.imagenPrincipal[0].title}
                            />
                            <h3 className="m-carousel-rates__images__title">
                              {val.tituloBanner}
                            </h3>
                            <p className="m-carousel-rates__images__subtitle">
                              {val.descripcion &&
                                JSON.parse(val.descripcion.raw).content[0]
                                  .content[0].value}
                            </p>
                            <Button
                              type="link"
                              text={val.tituloBoton}
                              classname={`primary __magentacolor  ${
                                val.descripcion &&
                                JSON.parse(val.descripcion.raw).content[0]
                                  .content.length > 4
                                  ? ""
                                  : "button-margin-image"
                              }  gtmRedDeAmorTarifaAdquirirServicio${normalizeTwoWords(
                                val.tituloBanner
                              )}`}
                              href={val.redireccionBoton}
                              isDisabled={false}
                              onClickAction={() => {}}
                            />
                          </div>
                        </CardRates>
                      ) : (
                        <CardRates
                          className={`${
                            isMenuActive === key ? "cardborder" : " cardnone"
                          }`}
                        >
                          <div className="m-carousel-rates__internal">
                            <div className="m-carousel-rates__internal__center">
                              <h3>{val.tituloBanner}</h3>
                            </div>
                            {val.descripcion &&
                              JSON.parse(
                                val.descripcion.raw
                              ).content[0]?.content.map((subVal, key2) => {
                                return (
                                  <div key={key2}>
                                    {key2 < 4 ? (
                                      <p>
                                        <span>
                                          {subVal.nodeType === "text"
                                            ? ""
                                            : subVal.content[0]?.content[0]
                                                ?.value
                                            ? subVal.content[0]?.content[0]
                                                ?.value
                                            : ""}
                                        </span>
                                        <strong>
                                          {" "}
                                          {subVal.nodeType === "text"
                                            ? ""
                                            : subVal.content[0]?.content[1]
                                                ?.value
                                            ? subVal.content[0]?.content[1]
                                                ?.value
                                            : ""}
                                        </strong>
                                        {subVal.nodeType === "text"
                                          ? ""
                                          : subVal.content[0]?.content[2]?.value
                                          ? subVal.content[0]?.content[2]?.value
                                          : ""}
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                );
                              })}
                            <div className="m-carousel-rates__internal__sesion">
                              {val.descripcion &&
                              JSON.parse(val.descripcion.raw).content[0].content
                                .length > 4 ? (
                                <p>
                                  {val.descripcion &&
                                    JSON.parse(val.descripcion.raw).content[0]
                                      .content[4].content[0].content[0].value}
                                </p>
                              ) : (
                                ""
                              )}
                              <Button
                                type="link"
                                text={val.tituloBoton}
                                classname={`primary __magentacolor  ${
                                  JSON.parse(val.descripcion.raw).content[0]
                                    .content.length > 4
                                    ? "button-margin"
                                    : "button-normal"
                                } `}
                                gtmMark={
                                  data.gigyaContext.gigyaAccount
                                    ? `gtmRedDeAmorSesionIniciadaTarifaAdquirirServicio${normalizeTwoWords(
                                        val.tituloBanner
                                      )}`
                                    : `gtmRedDeAmorTarifaAdquirirServicio${normalizeTwoWords(
                                        val.tituloBanner
                                      )}`
                                }
                                href={val.redireccionBoton}
                                isDisabled={false}
                                onClickAction={() => {}}
                              />
                            </div>
                          </div>
                        </CardRates>
                      )}
                    </div>
                  );
                })}
              </Slider>
            </div>
          </div>
        </div>
      )}
    </GlobalContext.Consumer>
  );
};

export default CarouselRates;
